import BrandFansGroupModalEditDescription from '././EditDescription'
import BrandFansGroupModalRename from './Rename'

export { BrandFansGroupModalRename, BrandFansGroupModalEditDescription }
